/**
 * Filters categories based on a whitelist.
 *
 * @param {string[]} whitelist - An array of category names to include.
 * @param {BaseFilterValue[]} categories - An array of category objects to filter.
 * @returns {BaseFilterValue[]} - An array of filtered categories that match the whitelist.
 */

import { BaseFilterValue } from '../Filters/types'

const normalise = (category: string) => category?.toLowerCase().trim()

export const getWhitelistedCategories = (
  whitelist: string[] = [],
  categories: BaseFilterValue[] = [],
): BaseFilterValue[] => {
  if (!whitelist || whitelist.length === 0) {
    return categories
  }

  return categories.filter((cat) =>
    whitelist.some((wl) => normalise(wl) === normalise(cat.value)),
  )
}
